import type { Key } from "react-aria-components";

/**
 * Key of the synthetic "Add ..." option. Options may not use it as their own
 * key — it is {@link useCreatableCombobox}'s namespace. An option that does
 * claim it wins: the "Add ..." entry is left out rather than shadowing real
 * data.
 */
export const comboboxCreateKey = "__combobox-create__";

/**
 * An item's collection key, read off the item object that
 * {@link useCreatableCombobox} was handed.
 *
 * react-aria resolves keys as `renderedItem.props.id ?? item.key ?? item.id`,
 * so this is only right while options are keyed by the object itself. Setting
 * `id` on the rendered {@link ComboboxItem} instead puts the real key out of
 * reach here, and the hook's labels — the "Add ..." exact-match test, the text
 * a single-select shows for its selection — stop finding their option. (Paste
 * matching reads the collection react-aria built instead, so it is unaffected;
 * see {@link readPasteOptions}.)
 */
export const readItemKey = (item: object): Key | undefined => {
  if ("key" in item) {
    return item.key as Key;
  }
  if ("id" in item) {
    return item.id as Key;
  }
  return undefined;
};
